import { useTranslationWithLang } from 'hooks/useTranslationWithLang';
import { Dialog, DialogContent } from '@mui/material';
import { FC, useState } from 'react';
import { TermsParser } from 'organisms/u002/TermsParser';
import { Form } from 'templates/Form';
import LoadingModal from 'organisms/LoadingModal';
import MessageModal from 'organisms/MessageModal';
import { TransitionButton } from 'atoms/TransitionButton';

type ConsentCheckProps = {
  open: boolean;
  onComplete: () => void;
  title: string;
  consentText: string;
  buttonLabel: string;
  loading: boolean;
};
export const ConsentCheck: FC<ConsentCheckProps> = (props) => {
  const { t: tConsent } = useTranslationWithLang('consent');
  const [errorMessage, setErrorMessage] = useState('');
  return (
    <>
      {errorMessage && (
        <MessageModal
          message={errorMessage}
          closeLabel={tConsent('TU015_002')}
          onClose={() => setErrorMessage('')}
        />
      )}
      <Dialog
        open={props.open}
        maxWidth="sm"
        fullWidth
        aria-modal="true"
        aria-labelledby="consent-dialog-title"
        PaperProps={{
          style: {
            color: 'var(--c-text)',
            padding: '4px',
            borderRadius: '10px',
            backgroundColor: 'var(--c-background2)',
            boxShadow: '0 3px 10px rgba(0, 0, 0, 0.2)',
          },
        }}
      >
        {props.loading && <LoadingModal />}
        <DialogContent sx={{ padding: '0px' }}>
          <div
            role="heading"
            aria-level={1}
            aria-live="assertive"
            id="consent-dialog-title"
            className="sr-only"
          >
            {props.title}
          </div>
          <Form title={props.title}>
            <div className="max-h-96 overflow-y-scroll my-10">
              <TermsParser text={props.consentText} />
            </div>
          </Form>
          <div className="flex justify-center">
            <TransitionButton
              onClick={() => {
                props.onComplete();
              }}
              label={tConsent('TU015_002')}
            />
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
